import { Refinement } from 'fp-ts/function';
import { fromRefinement } from 'io-ts-types';
import * as t from 'io-ts';
import { locales, supportedLocales, formLocales, supportedFormLocales } from '@/ui/i18n/i18n';

const isEnumValue = <EnumType>(theEnum: Record<string, string | number>) =>
  (input: unknown): input is EnumType =>
    Object
      .values<unknown>(theEnum)
      .includes(input);

//uses ts-io-types
export const getEnumCodec = <EnumType>(enumName: string, theEnum: Record<string, string | number>) => {
  const isT: Refinement<unknown, EnumType> = isEnumValue<EnumType>(theEnum);

  return fromRefinement(enumName, isT);
};

//uses native io-ts
export function fromEnum<EnumType>(enumName: string, theEnum: Record<string, string | number>) {
  const isThisEnumValue = isEnumValue<EnumType>(theEnum);

  return new t.Type<EnumType>(
    enumName,
    isThisEnumValue,
    (input, context) => (isThisEnumValue(input) ? t.success(input) : t.failure(input, context)),
    t.identity,
  );
}

export const localesUnionType = new t.Type<locales>(
  'locales',
  (input: unknown): input is locales => supportedLocales.includes(input as locales),
  (input, context) => supportedLocales.includes(input as locales)
    ? t.success<locales>(input as locales)
    : t.failure(input, context),
  t.identity,
);

export const formLocalesUnionType = new t.Type<formLocales>(
  'formLocales',
  (input: unknown): input is formLocales => supportedFormLocales.includes(input as formLocales),
  (input, context) => supportedFormLocales.includes(input as formLocales)
    ? t.success<formLocales>(input as formLocales)
    : t.failure(input, context),
  t.identity,
);

export type PartialExcept<T, E extends keyof T> = Pick<Required<T>, E> & Partial<Omit<T, E>>;

export type PartialRecord<K extends keyof never, T> = {
  [P in K]?: T;
};
